/**
 * devLog — gated console.log for hot-path tracing.
 *
 * Hot-path console.log is not free. Each call serializes its arguments and
 * hands them to the browser's log infrastructure; with DevTools open it
 * runs 1–3 ms per call. Across per-sentence + per-SM-transition + per-
 * event-node logs, a single response can burn several frames.
 *
 * Rule of thumb:
 *   - Use `devLog(...)` for anything that fires during talking / idle /
 *     gesture playback — blueprint node steps, SM transitions, per-message
 *     server mirrors, per-gesture routing, etc. It no-ops when the debug
 *     flag is off (single property read + empty function call, inlined by V8).
 *   - Keep plain `console.log(...)` for one-time startup logs (load summary,
 *     session id, clip bind report).
 *   - Keep `console.warn/error(...)` always — we want visibility of real
 *     problems without any opt-in.
 *
 * Enable at runtime:
 *   - URL:       ?debug=1   or   ?anim=1
 *   - Storage:   localStorage.debug = '1'   or   localStorage.anim = '1'
 */
const ENABLED = (typeof window !== 'undefined') && (() => {
  try {
    const p = new URLSearchParams(window.location.search)
    if (p.get('debug') === '1' || p.get('anim') === '1') return true
    if (localStorage.getItem('debug') === '1') return true
    if (localStorage.getItem('anim') === '1') return true
  } catch { /* storage blocked — fall through */ }
  return false
})()

export const DEV_LOG = ENABLED
export const devLog = ENABLED ? console.log.bind(console) : () => {}
